import { createContext } from 'react'

import {
  ILayout_ChangeEvent,
  ILayout_EditorEvent,
  ILayout_Options,
} from '@kaidam/fc-shared/src/types/layout'

import {
  LAYOUT_OPTIONS_WIDTH_DEFAULT,
} from '@kaidam/fc-shared/src/constants'

export interface IData_Editor_Event {
  id: string,
  action: 'edit' | 'delete',
}

interface IData_Editor_Context {
  options: ILayout_Options,
  changeEvent: ILayout_ChangeEvent | null,
  setChangeEvent: {
    (ev: ILayout_ChangeEvent | null): void,
  },
  editorEvent: ILayout_EditorEvent | null,
  setEditorEvent: {
    (ev: ILayout_EditorEvent | null): void,
  },
  selectionLocked: boolean,
  setSelectionLocked: {
    (value: boolean): void,
  },
}

export const getDefaultContext = ({
  options,
  changeEvent,
  setChangeEvent,
  editorEvent,
  setEditorEvent,
  selectionLocked,
  setSelectionLocked,
}: IData_Editor_Context): IData_Editor_Context => {
  const contextValue = {
    options,
    changeEvent,
    setChangeEvent,
    editorEvent,
    setEditorEvent,
    selectionLocked,
    setSelectionLocked,
  }
  return contextValue
}

const EditorContext = createContext<IData_Editor_Context>(getDefaultContext({
  options: {
    name: 'default',
    width: LAYOUT_OPTIONS_WIDTH_DEFAULT,
  },
  changeEvent: null,
  setChangeEvent: (value) => {},
  editorEvent: null,
  setEditorEvent: (value) => {},
  selectionLocked: false,
  setSelectionLocked: (value) => {},
}))

export default EditorContext